<template>
  <div>
    <custom-dialog width="466px" v-if="dialogObj.show" :visible="dialogObj.show" @close="close" @save="confirmValid">
      <div slot="header">
        <el-form class="patient-warp" ref="registerForm" inline :rules="rules" :model="registerForm">
            <el-form-item prop="patientName" class="mr4">
                <el-select ref="patientRef" :popper-append-to-body="false" popper-class="customSelectStyle"
                    class="name-select" v-model="registerForm.patientName" placeholder="患者姓名" filterable remote
                    reserve-keyword :remote-method="getPatientInfoByName" value-key="patientId"
                    @change="selectPatient">
                    <el-option v-for="item in patientList" :key="item.patientId" :value="item" class="display-f">
                        <span style="width: 96px; display:inline-block;" class="mr12 text-overflow">{{
                            item.patientName }}</span>
                        <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                        <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth
                        }}月</span>
                        <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="sex" class="mr4">
                <el-select disabled :popper-append-to-body="false" popper-class="customSelectStyle"
                    class="sex-select" v-model="registerForm.sex">
                    <el-option v-for="item in [{ label: '男', value: '0' }, { label: '女', value: '1' }]"
                        :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item prop="year" class="mr4">
                <el-input disabled ref="year" class="year-input" v-model.number="registerForm.year"
                    @blur="computeBirthday">
                </el-input>
                <div class="append">岁</div>
            </el-form-item>
            <el-form-item prop="month" class="mr4">
                <el-input disabled ref="month" class="year-input" v-model.number="registerForm.month"
                    @blur="computeBirthday">
                </el-input>
                <div class="append">月</div>
            </el-form-item>
            <el-form-item prop="phone" class="mr4">
                <el-select :popper-append-to-body="false" popper-class="customSelectStyle" class="phone-select"
                    v-model="registerForm.phone" placeholder="患者手机号" filterable remote reserve-keyword
                    :remote-method="getPatientInfoByPhone" value-key="patientId" @change="selectPatient">
                    <el-option v-for="item in patientList" :key="item.patientId" :value="item">
                        <span style="width: 96px; display:inline-block" class="mr12">{{ item.patientName }}</span>
                        <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                        <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth
                        }}月</span>
                        <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                    </el-option>
                </el-select>
                <div class="close-icon iconfont icon-cha" @click="clearPatient" v-if="registerForm.patientId"></div>
                <div class="edit-icon iconfont icon-xiug" @click="editPatient" v-if="registerForm.patientId"></div>
            </el-form-item>
            <div class="add-btn" @click="handleAddPatient">
                <span class="iconfont icon-xinzenghuanz icon-1F2329"></span>
            </div>
        </el-form>
      </div>
      <div slot="content" class="registerForm-warp">
          <el-form size="" inline :rules="rules" :model="registerForm" ref="registerForm">
              <div class="content-warp">
                  <div class="display-f">
                      <el-form-item label="医生" prop="doctorId" class="mr8">
                          <custom-select disabled class="select-el-input__inner" :configs="doctorOptionsConfig"
                              :popper-append-to-body="false" filterable v-model="registerForm.doctorId"
                              placeholder="医生姓名" :options="doctorOptions"></custom-select>
                      </el-form-item>
                      <el-form-item prop="doctorVisit">
                          <custom-select disabled :popper-append-to-body="false" popper-class="customSelectStyle"
                              class="select-el-input__inner" v-model="registerForm.doctorVisit" placeholder="患者类型"
                              :options="doctorVisitList"></custom-select>
                      </el-form-item>
                  </div>
                  <div class="display-f">
                      <el-form-item label="日期" prop="schedulingTime" class="mr8">
                          <!-- <el-input class="date-input" v-model="registerForm.date" prefix-icon="el-icon-date"></el-input> -->
                          <el-date-picker ref="datePicker" popper-class="customDate" :append-to-body="false"
                              v-model="registerForm.schedulingTime" class="date-input" type="date"
                              value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions"
                              @change="dateChange">
                          </el-date-picker>
                      </el-form-item>
                      <el-form-item prop="schedulingItemId">
                          <custom-select class="select-el-input__inner" :configs="schedulingOptionsConfig"
                              @focus="schedulingItemFocus" v-model="registerForm.schedulingItemId" placeholder="就诊班次"
                              @change="schedulingItemChange" :options="schedulingOptions"></custom-select>
                      </el-form-item>
                  </div>
                  <div class="display-f">
                      <el-form-item label="类型" prop="type" class="mr8">
                          <custom-select class="select-el-input__inner" v-model="registerForm.type" placeholder="门诊类型"
                              @change="typeChange" :options="typeOptions"></custom-select>
                      </el-form-item>
                      <el-form-item>
                          <custom-select class="select-el-input__inner"
                              :disabled="registerForm.type == '1' || registerForm.type == '3' || registerForm.type == '6' || registerForm.type == '7'"
                              v-model="registerForm.timeQuantumId" placeholder="就诊时间" :configs="timeRangeListConfig"
                              :options="timeRangeList"></custom-select>
                      </el-form-item>
                  </div>
                  <div>
                      <el-form-item label="费用" prop="price" class="mr8">
                          <el-input class="charge-input" :disabled="registerForm.type == 5"
                              v-model="registerForm.price"></el-input>
                          <div class="charge-icon">¥</div>
                          <div class="text-icon" v-if="!registerForm.revisitDiscount && isShowAdd">加号</div>
                          <div class="text-icon" v-if="registerForm.revisitDiscount">复诊</div>
                      </el-form-item>
                  </div>
              </div>
          </el-form>
      </div>
    </custom-dialog>
    <custom-dialog width="400px" v-if="locksetDialogShow" :visible="locksetDialogShow"  @close="locksetDialogClose">
      <div class="lockset-title" slot="header">
          <div> <span class="iconfont icon-chenggong icon-29C01B mr5"></span>锁号成功</div>
          <i class="el-icon-close" @click="locksetDialogShow=false"></i>
      </div>
      <div class="lockset-content" slot="content">
          <div class="lockset-tips">
            <div>提示：</div>
            <div>顾客可通过【小程序】或【到收银台】支付挂号费； 超过【1天未支付】，系统将会自动取消号源。</div>
          </div>
          <div class="content-item">
              <span class="iconfont icon-haoyuan icon-9AA0A8 mr10"></span>
              <div class="rigth-line"> 号源：{{ registerInfo.schedulingTime }}</div>
              <div class="rigth-line"> {{ registerInfo.timeQuantumName }}</div>
              <div class="rigth-line"> {{ registerInfo.timeName }}{{ registerInfo.registeredCode }}号</div>
          </div>
          <div class="content-item">
              <span class="iconfont icon-yishengg icon-9AA0A8 mr10"></span>
              <div class="rigth-line">医生：{{ registerInfo.doctorName }}</div>
          </div>
          <div class="content-item">
              <span class="iconfont icon-zhenshi icon-9AA0A8 mr10"></span>
              <div class="rigth-line">诊室：{{ registerInfo.clinicName || '暂无' }}</div>
          </div>
      </div>
      <div class="btns" slot="footer">
          <custom-button size="small" type="primary" @click="locksetDialogClose">关闭</custom-button>
      </div>
    </custom-dialog>
    <addPatient :visibleObj="visiblePatientObj" :patientInfo="registerForm" :title='patientDialogTitle' @addPatientComfirm="addPatientComfirm" @close="visiblePatientObj.addPatientDialog = false" :addPatientType="addPatientType"></addPatient>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import addPatient from '@/components/addPatient'
import { patientInfom } from "@/api/patient"; // 病人列表请求
import { isNull, isEmptyArray, debounce ,isNullObj} from '@/utils/validateBase'
import { getSchedulingTime, getDoctorVisit, doctorSchedulingList } from '@/api/register'
import { Utils } from '@/utils/utils'
import { scheduleInfo, getTimeQuantumList } from "@/api/schedule"; // 排班请求
import { doctorVisitList } from '@/utils/const'
import CustomSelect from '@/components/CustomSelect'
import { registerAdd } from "@/api/registration"; // 挂号请求
import { visibleObj } from '@/components/js/dialog'
import { getRevisitRegisterPrice } from '@/api/doctor'
export default {
  components:{ CustomDialog , addPatient, CustomSelect },
  props:{
    dialogObj: {
            type: Object,
            default: {}
        },
  },
  data(){
    return{
      visiblePatientObj: visibleObj,
      pickerOptions: {
        cellClassName: (date) => {
            let _currentData = this.getTime(date)
            let _dataObj = {}
            this.schedulingItemList.forEach(item => {
                let time = this.$moment(item.schedulingTime).startOf('day').valueOf()
                _dataObj[time] = item.surNum
            })
            if (_dataObj[_currentData] > 0 && !Utils.lt(this.$moment(date).startOf('day').valueOf(), this.$moment().startOf('day').valueOf())) {
                return `cell-num-data-${_dataObj[_currentData]}`
            }
        },
        disabledDate: (date) => {
            if (Utils.lt(this.$moment(date).startOf('day').valueOf(), this.$moment().startOf('day').valueOf())) {
                return true;
            } else {
                return false;
            }
        }
      },
      doctorVisitList: doctorVisitList,//初诊复诊列表
      rules: {
        price: [
            { required: true, message: '挂号费用不能为空', trigger: 'blur' }
        ],
        doctorId: [
            { required: true, message: '医生姓名不能为空', trigger: 'change' }
        ],
        schedulingTime: [
            { required: true, message: '就诊日期不能为空', trigger: 'change' }
        ],
        schedulingItemId: [
            { required: true, message: '就诊班次不能为空', trigger: 'change' }
        ],
        type: [
            { required: true, message: '门诊类型不能为空', trigger: 'change' }
        ],
      },//验证规则
      patientList: [],//患者列表
      doctorOptions: [],//医生列表
      schedulingItemList: [],//医生这个月的全部排班列表
      registerForm: {
          deptId: this.$session.get('deptId'),
          patientName: '',//患者姓名
          sex: '0',//患者性别
          doctorName: '',//医生姓名
          month: '',//月份
          year: "",//岁
          schedulingTime: '',//日期
          type: '',//门诊类型
          timeQuantumId: '',//就诊时间
          schedulingItemId: '',//班次id
          doctorVisit: '0',//初诊、复诊
          price: '',
          revisitDiscount: false
      },
      typeOptions: [],//门诊类型
      schedulingOptions: [], // 医生排班选项
      timeRangeList: [],//就诊时间段
      doctorOptionsConfig: {
          value: 'doctorId',
          label: 'doctorName'
      },//医生下拉配置
      schedulingOptionsConfig: {
          value: 'schedulingItemId',
          label: 'timeName'
      },//就诊班次下拉配置
      timeRangeListConfig: {
          value: 'id',
          label: 'name',
          text: 'label'
      },//就诊时间下拉配置
      patientDialogTitle: '新增患者',//新增患者弹框
      addPatientType: '',//患者弹框type
      locksetDialogShow:false,//锁好弹框
      registerInfo:{},
    }
  },
  computed: {
    isShowAdd() {
        if (this.registerForm.type == 1 || this.registerForm.type == 3 || this.registerForm.type == 6 || this.registerForm.type == 7) {
            return true;
        } else {
            return false;
        }
    },
  },
  // 页面初始化
  created() {
      let { doctorInfo, patientInfo } = this.dialogObj
      this.registerForm.doctorId = doctorInfo.doctorId
      this.registerForm.doctorName = doctorInfo.doctorName
      if(!isNull(patientInfo) || !isNullObj(patientInfo)){
        this.registerForm = {
          ...this.registerForm,
          ...patientInfo
        }
        this.getDoctorVisit();
      }
      this.doctorOptions.push({ doctorName: doctorInfo.doctorName, doctorId: doctorInfo.doctorId });
      this.getSchedulingTime();
      if (!isNull(doctorInfo.doctorId)) { this.getDoctorSchedulingListByMonth(doctorInfo.doctorId); }
  },
  // 页面方法
  methods: {
    getTime(date) {
        // 获取日期的时间戳
        return this.$moment(date).startOf('day').valueOf()
    },
    // 计算生日
    computeBirthday() {
        this.registerForm.birthday = this.$computeBirthday(this.registerForm.year, this.registerForm.month);
    },
    /**
     * 确认额
     */
    confirmValid: debounce(function(){
        if (isNull(this.registerForm.patientId) || isNull(this.registerForm.month) || isNull(this.registerForm.year) || isNull(this.registerForm.phone)) {
            return this.$message.error('请填写患者信息或创建新患者')
        }
        this.$refs.registerForm.validate(valid => {
            if (valid) {
                if (this.registerForm.timeQuantumId) {
                    const endTimePoint = this.timeRangeList.find(item => { return item.id == this.registerForm.timeQuantumId }).endTimePoint
                    const registerTime = `${this.registerForm.schedulingTime} ${endTimePoint}`
                    if (new Date().getTime() > new Date(registerTime).getTime()) {
                        this.$confirm('当前所选就诊时间为过去时段，可能影响其他患者看诊顺序，是否保持当前选择？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.confirm()
                        }).catch(() => {})
                    } else {
                        this.confirm()
                    }
                } else {
                    this.confirm()
                }
            }
        })
    }, 800, true),
    async confirm () {
        this.registerForm.intoType='2'
        let {code,data} = await registerAdd(this.registerForm)
        if (code == 200) {
            this.registerInfo = data
            this.locksetDialogShow = true;
        } 
    },
    /**
     * 关闭
     */
    close() {
        this.$emit("closeRegister");
    },
    /**
     * 新增患者
     */
    handleAddPatient() {
        this.addPatientType = 'add'
        this.visiblePatientObj.addPatientDialog = true;
    },
    // 根据姓名获取患者列表
    getPatientInfoByName: debounce(async function (name) {
        let { code, data } = await patientInfom({ name })
        this.patientList = [];
        if (code == 200) {
            data.forEach(item => { this.$computeAge(item.birthday, item) })
            this.patientList = data;
        }
    }, 300),
    // 根据姓名获取患者列表
    getPatientInfoByPhone: debounce(async function (phone) {
        let { code, data } = await patientInfom({ phone })
        this.patientList = [];
        if (code == 200) {
            data.forEach(item => { this.$computeAge(item.birthday, item) })
            this.patientList = data;
        }
    }, 200),
    /**
     * 选择患者
     */
    selectPatient(item) {
        let { patientId, patientName, phone, age, ageMth, sex, birthday,idCard } = item
        this.registerForm = {
            ...this.registerForm,
            patientId, patientName, phone, year: age, month: ageMth, sex, birthday,idCard
        }
        this.patientList = []
        this.getDoctorVisit();
        this.getRevisitRegisterPrice()
    },
    /**
     * 查询医生班次
     */
    async getSchedulingTime() {
        if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.schedulingTime)) return;
        this.schedulingOptions = [];
        let { code, data } = await getSchedulingTime({ doctorId: this.registerForm.doctorId, schedulingTime: this.registerForm.schedulingTime })
        if (code == 200 && !isEmptyArray(data)) {
            data.forEach(item => {
                this.schedulingOptions.push({
                    timeName: item.timeName,
                    timeId: item.timeId,
                    schedulingItemId: item.schedulingItemId,
                    clinicName: item.clinicName,
                    typeOptions: this.handleTypeOption(item)
                })
            })
            this.registerForm.schedulingItemId = this.schedulingOptions[0].schedulingItemId
            this.registerForm.timeName = this.schedulingOptions[0].timeName
            this.registerForm.timeId = this.schedulingOptions[0].timeId
            this.registerForm.clinicName = this.schedulingOptions[0].clinicName
            this.typeOptions = this.schedulingOptions[0].typeOptions;
            this.registerForm.type = this.schedulingOptions[0].typeOptions[0].value
            this.registerForm.price = this.schedulingOptions[0].typeOptions[0].price
            this.getTimeQuantumList(this.registerForm.schedulingItemId, this.registerForm.type)
            this.getRevisitRegisterPrice()
        } else {
            this.registerForm.type = ''
            this.registerForm.timeId = ''
            this.registerForm.schedulingItemId = ''
            this.registerForm.timeQuantumId = ''
            this.typeOptions = []
            this.schedulingOptions = []
            this.timeRangeList = []
        }
    },
    /**
     * 处理门诊类型数据
     * isPhysio=1有理疗类型 isContributing=1有特约 isFree != 0有义诊 isFree !=2 有普通
     * 0日常 1日常加号 2特约 3特约加号 4理疗 5义诊 6理疗加号 7义诊加号
     */
    handleTypeOption(item) {
      let typeOptions = []
      if (item.isCommon === 1) {
        if (Utils.gt(item.surComNum, 0)) {
          typeOptions.push({ label:item.isIncrease ? '普通门诊加号' : '普通门诊', value: 0, price: item.registrationCommonPrice })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '普通门诊加号', value: 1, price: item.registrationCommonIncreasePrice })
        }
      }
      if (item.isContributing == '1') {
        if (Utils.gt(item.surCtrNum, 0)) {
          typeOptions.push({ label:item.isIncrease ? '特约门诊加号' : '特约门诊', value: 2, price: item.registrationContributingPrice })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '特约门诊加号', value: 3, price: item.registrationContributingIncreasePrice })
        }
      }
      if (item.isPhysio == '1') {
        if (Utils.gt(item.surPhyNum, 0)) {
          typeOptions.push({ label: item.isIncrease ? '理疗门诊加号' : '理疗门诊', value: 4, price: item.registrationPhysioPrice })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '理疗门诊加号', value: 6, price: item.registrationCtbPhysioPrice })
        }
      }
      if (item.isFree != '0') {
        if (Utils.gt(item.surFreNum, 0)) {
          typeOptions.push({ label: '义诊', value: 5, price: 0 })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '义诊加号', value: 7, price: 0 })
        }
      }
      if(item.isTransfer == '1'){
        if (Utils.gt(item.surTraNum, 0)) {
          typeOptions.push({ label: '转方', value: 10, price: item.registrationTransferPrice })
        }else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease){
          typeOptions.push({ label: '转方加号', value: 11, price: item.registrationTransferIncreasePrice })
        } 
      }

      return typeOptions;
    },
    /**
     * 班次改变
     */
    schedulingItemChange(id) {
        if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.schedulingTime)) return this.$message.error('请先选择医生和日期')
        let obj = this.schedulingOptions.find(item => { return item.schedulingItemId == id })
        this.typeOptions = obj.typeOptions
        this.registerForm.schedulingItemId = id;
        this.registerForm.type = obj.typeOptions[0].value
        this.registerForm.price = obj.typeOptions[0].price
        this.registerForm.timeId = obj.timeId
        this.registerForm.timeName = obj.timeName
        this.getTimeQuantumList(this.registerForm.schedulingItemId, this.registerForm.type)
        this.getRevisitRegisterPrice()
    },
    /**
     * 类型改变
     */
    typeChange(val) {
        let index = this.typeOptions.findIndex(item => { return item.value == val })
        this.registerForm.type = val
        this.registerForm.price = this.typeOptions[index].price;
        this.getTimeQuantumList(this.registerForm.schedulingItemId, this.registerForm.type)
        this.getRevisitRegisterPrice()
    },
    /**
     * 就诊班次输入框聚焦
     */
    schedulingItemFocus() {
        if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.schedulingTime)) this.$message.error('请先选择医生和日期')
    },
    /**
     * 获取排班下时间段
     * id 排班id
     * type 门诊类型
    */
    getTimeQuantumList(id, type) {
        let param = {
            schedulingItemId: id
        }
        if (!isNull(type)) param.schedulingType = type+''
        getTimeQuantumList(param).then(res => {
            let { code, data } = res
            if (code == 200) {
                if (data.length > 0) {
                    let index = data.findIndex(item => { return item.surNumber > 0 })
                    this.registerForm.timeQuantumId = data[index].id
                    this.registerForm.timeQuantumName = data[index].name
                    // this.timeRangeList = data
                    // 处理时间段显示数据
                    data.forEach(item => {
                        item.label = `${item.name}(${item.surNumber})`
                        item.disabled = !Utils.gt(item.surNumber, 0)
                    })
                    this.timeRangeList = data
                } else {
                    this.registerForm.timeQuantumId = ''
                    this.registerForm.timeQuantumName = ''
                }
            }
        })
    },
    /**
    * 选择就诊时间
    * id 就诊时间id
    */
    timeQuantumChange(id) {
        let obj = this.timeRangeList.find(item => {
            return item.id == id
        })
        this.registerForm.timeQuantumId = id
        this.registerForm.timeQuantumName = obj.name
    },
    /**
     * 查询初诊复诊
     */
    async getDoctorVisit() {
        let { doctorId, patientId } = this.registerForm
        if (isNull(doctorId) || isNull(patientId)) return;
        let { code, data } = await getDoctorVisit({ doctorId, doctorId, patientId, patientId,orderId: ''})
        if (code == 200) {
            this.registerForm.doctorVisit = data;
        }
    },
    /**
    * 新增患者确认
    */
    addPatientComfirm(data) {
        let { patientId, patientName, phone, age, ageMth, sex, birthday } = data
        this.registerForm = {
            ...this.registerForm,
            patientId, patientName, phone, year: age, month: ageMth, sex, birthday
        }
        this.visiblePatientObj.addPatientDialog = false;
    },
    /**
    * 获取某个医生这个月的排班列表
    * id 医生id
    */
    async getDoctorSchedulingListByMonth(id) {
        let obj = {
            doctorId: id,
            deptId: this.$session.get('deptId'),
            startTime: this.$moment(this.dialogObj.schedulingTime).startOf('month').format('YYYY-MM-DD'),
            stopTime: this.$moment(this.dialogObj.schedulingTime).endOf('month').format('YYYY-MM-DD'),
        }
        let { code, rows } = await doctorSchedulingList(obj);
        if (code == 200 && !isEmptyArray(rows)) {
            console.log(rows, 2222);
            this.schedulingItemList = rows;
        }
    },
    /**
     * 清空患者
     */
    clearPatient() {
        this.registerForm.birthday = ''
        this.registerForm.month = ''
        this.registerForm.patientId = ''
        this.registerForm.patientName = ''
        this.registerForm.phone = ''
        this.registerForm.sex = ''
        this.registerForm.year = ''
        this.registerForm.doctorVisit = '0'
        this.registerForm.revisitDiscount = false
        this.patientList = []

        const scheduling = this.schedulingOptions.find(item => { return item.schedulingItemId == this.registerForm.schedulingItemId })
        if (scheduling) {
            const typeInfo = scheduling.typeOptions.find(item => { return item.value == this.registerForm.type })
            if (typeInfo) {
                this.registerForm.price = typeInfo.price
            }
        }
    },
    /**
     * 修改患者
     */
    editPatient() {
        this.patientDialogTitle = '修改患者'
        this.addPatientType = 'edit'
        this.visiblePatientObj.addPatientDialog = true;
    },
    /**
     * 切换日期
     */
    async dateChange() {
        let index = this.doctorOptions.findIndex(item => { return item.doctorId == this.registerForm.doctorId })
        if (Utils.gt(index, -1)) {
            this.getSchedulingTime()
        } else {
            this.typeOptions = []
            this.registerForm.type = ''
            this.registerForm.schedulingItemId = ''
            this.registerForm.timeQuantumId = ''
            this.registerForm.timeQuantumName = ''
            this.registerForm.price = ''
        }
    },
    //锁好关闭
    locksetDialogClose(){
      this.locksetDialogShow = false;
      this.close();
    },
    // 获取复诊价格
    async getRevisitRegisterPrice() {
      if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.patientId) || isNull(this.registerForm.schedulingItemId) || isNull(this.registerForm.type)) return;
      let { code, data } = await getRevisitRegisterPrice({
        deptId: this.$session.get('deptId'),
        doctorId: this.registerForm.doctorId,
        patientId: this.registerForm.patientId,
        schedulingItemId: this.registerForm.schedulingItemId,
        registerType: String(this.registerForm.type)
      })
      if (code == 200) {
        this.registerForm.revisitDiscount = data.revisitDiscount
        this.registerForm.price = data.finalPrice
      }
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .dialog-content {
    padding-top: 12px !important;
}

::v-deep .el-dialog__body {
    padding: 0 !important;
}

::v-deep .el-date-table th {
    text-align: center;
}

::v-deep .el-form-item__error {
    padding-top: 4px;
}

::v-deep .el-form-item__content {
    line-height: 32px;
}

.patient-warp {
    display: flex;
    border-bottom: 1px solid #EBEAEE;
    padding: 16px;

    .close-icon {
        position: absolute;
        top: 2px;
        right: 10px;
    }

    .edit-icon {
        position: absolute;
        top: 2px;
        right: 30px;
        font-size: 12px;
    }

    .el-form-item {
        margin-bottom: 0;

    }



    .name-select {
        width: 86px;

        ::v-deep .el-input__suffix {
            display: none;
        }
    }

    .sex-select {
        width: 38px;

        ::v-deep .el-input__inner {
            text-align: center;
        }

        ::v-deep .el-input__suffix {
            display: none;
        }
    }

    .year-input {
        width: 56px;
        position: relative;
    }

    .append {
        position: absolute;
        top: 0;
        right: 10px;
        color: #1F2329;
        font-size: 14px;
    }

    .phone-select {
        width: 146px;

        ::v-deep .el-input__suffix {
            display: none;
        }
    }

    .add-btn {
        width: 32px;
        height: 35px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #D3D3D5;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.mr4 {
    margin-right: 4px !important;
}

.mr8 {
    margin-right: 8px !important;
}

.el-input,
.el-select {
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    box-sizing: border-box;
}

::v-deep .el-input__inner {
    padding: 6px 6px;
    border: none;
    box-sizing: border-box;
}


::v-deep .el-input.is-disabled .el-input__inner {
    background: #fff;
}

.registerForm-warp {
    .el-form-item {
        height: 32px;
    }
}

.content-warp {
    margin-top: 16px;
    ::v-deep .el-form-item {
        display: flex;
        margin-right: 0;
    }

    ::v-deep .el-form-item__label {
        flex-shrink: 0;
        flex-grow: 0;
    }

    ::v-deep .el-input__inner {
        width: 183px;
    }



    .date-input {
        width: 100%;

        ::v-deep .el-input__inner {
            padding-left: 28px;
        }
    }

    .charge-input {
        position: relative;
        width: 378px;

        ::v-deep .el-input__inner {
            padding-left: 24px;
            width: 100%;
        }
    }

    .charge-icon {
        position: absolute;
        top: 2px;
        left: 12px;
        color: #667182;
        font-size: 14px;
    }

    .text-icon {
        height: 22px;
        position: absolute;
        right: 12px;
        top: 6px;
        padding: 2px 6px;
        border-radius: 2px;
        box-sizing: border-box;
        background: #FFF0E1;
        color: #FE8F1F;
        font-size: 12px;
        display: flex;
        align-items: center;
    }
}

.brn-warp {
    text-align: right;
    margin-top: 14px;
    padding-right: 24px;
}

::v-deep .customDate {
    @for $i from 1 through 200 {
        .cell-num-data-#{$i} span {
            &::after {
                content: "余#{$i}";
                width: 32px;
                display: block;
                max-width: 50px;
                font-size: 12px;
                color: #1890FF;
                position: absolute;
                top: 18px;
                left: 0;
            }
        }
    }
}

::v-deep .el-input.is-disabled .el-input__inner {
    color: #1F2329;
}

.select-el-input__inner {
    border: 1px solid #DCDFE6 !important;
}
.rigth-line {
  padding-right: 6px;
  padding-left: 3px;
  border-right: 1px solid #EBEAEE;
  flex-grow: 0;
  flex-shrink: 0;
  &:last-child {
      border-right: none
  }
}
.lockset-title {
  position: relative;
  color: #1F2329;
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid #EBEAEE;
  padding: 12px;
  font-weight: 500;
  .el-icon-close {
      position: absolute;
      top: 15px;
      right: 16px;
  }
}
.lockset-tips{
  padding: 8px;
  background: #F7F8F9;
  border-radius: 2px;
  border: 1px solid #EBEAEE;
  font-size: 14px;
  color: #667182;
  line-height: 20px;
  margin-bottom: 16px;
}
.lockset-content {
    .content-item {
        display: flex;
        color: #1F2329;
        font-size: 14px;
        margin-bottom: 24px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
.btns {
    display: flex;
    padding-right: 24px;
    justify-content: flex-end;
    padding-bottom: 16px;
}
</style>